import { createContext } from "react";

export const context = createContext({
    ostan: null,
    setOstan: () => {},
    shahrestan: null,
    setShahrestan: () => {},
    shahr: null,
    setShahr: () => {},
    isModalOpen: null,
    setIsModalOpen: () => {},
    provinces: null,
    setProvinces: () => {},
    forceUpdate: null,
    setForceUpdate: () => {},
    ostanIcon: null,
    setOstanIcon: () => {},
    ostanName: null,
    setOstanName: () => {},
    ostanColor: null,
    setOstanColor: () => {},
    ostanId: null,
    setOstanId: () => {},
    isEditShow: null,
    setIsEditShow: () => {},
    country: null,
    setCountry: () => {},
    parentOstanId: null,
    setParentOstanId: () => {},
    countryId: null,
    setCountryId: () => {},
    shahrestanName: null,
    setShahrestanName: () => {},
    shahrestanIcon: null,
    setShahrestanIcon: () => {},
    shahrestanColor: null,
    setShahrestanColor: () => {},
    shahrestanId: null,
    setShahrestanId: () => {},
    city: null,
    setCity: () => {},
    cityId: null,
    setCityId: () => {},
    cityName: null,
    setCityName: () => {},
    cityIcon: null,
    setCityIcon: () => {},
    cityColor: null,
    setCityColor: () => {},
    cityTag: null,
    setCityTag: () => {},
    village: null,
    setVillage: () => {},
    isCitySelected: null,
    setIsCitySelected: () => {},
    placeCategories: null,
    setPlaceCategories: () => {},
    placeName: null,
    setPlaceName: () => {},
    placeIcon: null,
    setPlaceIcon: () => {},
    placeTag: null,
    setPlaceTag: () => {},
    placeMapIcon: null,
    setPlaceMapIcon: () => {},
    placeId: null,
    setPlaceId: () => {},
    placeColor: null,
    setPlaceColor: () => {},
    isAddSubset: null,
    setIsAddSubset: () => {},
    child: null,
    setChild: () => {},
    dataPlaces: null,
    setDataPlaces: () => {},
    addNamePlace: null,
    setAddNamePlace: () => {},
    addUrlPlace: null,
    setAddUrlPlace: () => {},
    addLinkPlace: null,
    setAddLinkPlace: () => {},
    addAddressPlace: null,
    setAddAddressPlace: () => {},
    addPhonePlace: null,
    setAddPhonePlace: () => {},
    latLng: null,
    setLatLng: () => {},
    textEditorShow: null,
    setTextEditorShow: () => {},
    placeFormTag: null,
    setPlaceFormTag: () => {},
    linkTags: null,
    setLinkTags: () => {},
    addKindLinkPlace: null,
    setAddKindLinkPlace: () => {},
    isProvinceSelected: null,
    setIsProvinceSelected: () => {},
    isCountrySelected: null,
    setIsCountrySelected: () => {},
    isCategorySelected: null,
    setIsCategorySelected: () => {},
    textEditorHTML: null,
    setTextEditorHTML: () => {},
    selectedPlaceId: null,
    setSelectedPlaceId: () => {},
    selectedContentId: null,
    setSelectedContentId: () => {},
    addUrlContent: null,
    setAddUrlContent: () => {},
    addKindLinkContent: null,
    setAddKindLinkContent: () => {},
    addLinkContent: null,
    setAddLinkContent: () => {},
    addAddressContent: null,
    setAddAddressContent: () => {},
    addPhoneContent: null,
    setAddPhoneContent: () => {},
    addNameContent: null,
    setAddNameContent: () => {},
    dataContents: null,
    setDataContents: () => {},
    fpHash: null,
    setFpHash: () => {},
    placesId: null,
    setPlacesId: () => {},
    selectedCityId: null,
    setSelectedCityId: () => {},
    selectedCategoryId: null,
    setSelectedCategoryId: () => {},
    selectedCountry: null,
    setSelectedCountry: () => {},
    selectedProvince: null,
    setSelectedProvince: () => {},
    selectedSubCategoryId: null,
    setSelectedSubCategoryId: () => {},
    editedCity: null,
    setEditedCity: () => {},
    editedCountry: null,
    setEditedCountry: () => {},
    editedProvince: null,
    setEditedProvince: () => {},
    editedSubCategory: null,
    setEditedSubCategory: () => {},
    editedCategory: null,
    setEditedCategory: () => {},
    contentId: null,
    setContentId: () => {},
    fileList: null,
    setFileList: () => {},
    coverPic: null,
    setCoverPic: () => {},
    coverPicId: null,
    setCoverPicId: () => {},
    fileListIds: null,
    setFileListIds: () => {},
    selectedPlaceProvinceId: null,
    setSelectedPlaceProvinceId: () => {},
    selectedLinkId: null,
    setSelectedLinkId: () => {},
    linkestanTags: null,
    setLinkestanTags: () => {},
    linkTitle: null,
    setLinkTitle: () => {},
    newLinks: null,
    setNewLinks: () => {},
    linkColor: null,
    setLinkColor: () => {},
    linkIcon: null,
    setLinkIcon: () => {},
    linkUrl: null,
    setLinkUrl: () => {},
    linkMedia: null,
    setLinkMedia: () => {},
    linkMediaId: null,
    setLinkMediaId: () => {},
    linkCover: null,
    setLinkCover: () => {},
    linkCoverId: null,
    setLinkCoverId: () => {},
    linkestanIcon: null,
    setLinkestanIcon: () => {},
    selectedNewsId: null,
    setSelectedNewsId: () => {},
    newsCoverId: null,
    setNewsCoverId: () => {},
    newsCover: null,
    setNewsCover: () => {},
    newsMediaId: null,
    setNewsMediaId: () => {},
    newsMedia: null,
    setNewsMedia: () => {},
    newsLinkUrl: null,
    setNewsLinkUrl: () => {},
    newsLinkIcon: null,
    setNewsLinkIcon: () => {},
    newsLinkColor: null,
    setNewsLinkColor: () => {},
    newsLinks: null,
    setNewsLinks: () => {},
    newsTitle: null,
    setNewsTitle: () => {},
    newsTags: null,
    setNewsTags: () => {},

    selectedEventId: null,
    setSelectedEventId: () => {},
    eventTags: null,
    setEventTags: () => {},
    eventTitle: null,
    setEventTitle: () => {},
    eventLinks: null,
    setEventLinks: () => {},
    eventLinkColor: null,
    setEventLinkColor: () => {},
    eventLinkIcon: null,
    setEventLinkIcon: () => {},
    eventLinkUrl: null,
    setEventLinkUrl: () => {},
    eventMedia: null,
    setEventMedia: () => {},
    eventMediaId: null,
    setEventMediaId: () => {},
    eventCover: null,
    setEventCover: () => {},
    eventCoverId: null,
    setEventCoverId: () => {},
    eventStartDate: null,
    setEventStartDate: () => {},
    eventEndDate: null,
    setEventEndDate: () => {},
    linkAddress: null,
    setLinkAddress: () => {},
    selectedFeedBackId: null,
    setSelectedFeedBackId: () => {},
    feedBackStartDate: null,
    setFeedBackStartDate: () => {},
    feedBackEndDate: null,
    setFeedBackEndDate: () => {},
    feedBackStartText: null,
    setFeedBackStartText: () => {},
    feedBackEndText: null,
    setFeedBackEndText: () => {},
    feedBackStepTwoId: null,
    setFeedBackStepTwoId: () => {},
    feedBackAnswers: null,
    setFeedBackAnswers: () => {},
    feedBackQuestionText: null,
    setFeedBackQuestionText: () => {},
    feedBackData: null,
    setFeedBackData: () => {},
    isInteractionModalOpen: null,
    setIsInteractionModalOpen: () => {},
    isNoticeModalOpen: null,
    setIsNoticeModalOpen: () => {},
    feedBackTitle: null,
    setFeedBackTitle: () => {},

    selectedTravelId: null,
    setSelectedTravelId: () => {},
    travelTitle: null,
    setTravelTitle: () => {},
    travelPlaces: null,
    setTravelPlaces: () => {},
    travelContent: null,
    setTravelContent: () => {},
    travelGeo: null,
    setTravelGeo: () => {},
    travelTags: null,
    setTravelTags: () => {},
    travelTime: null,
    setTravelTime: () => {},
    travelMedia: null,
    setTravelMedia: () => {},
    travelMediaId: null,
    setTravelMediaId: () => {},
    travelCover: null,
    setTravelCover: () => {},
    travelCoverId: null,
    setTravelCoverId: () => {},
    isAdminModalOpen: null,
    setIsAdminModalOpen: () => {},
    discountTitle: null,
    setDiscountTitle: () => {},
    discountDescription: null,
    setDiscountDescription: () => {},
    discountLinkUrl: null,
    setDiscountLinkUrl: () => {},
    discountLinkTitle: null,
    setDiscountLinkTitle: () => {},
    discountLinks: null,
    setDiscountLinks: () => {},
    discountTags: null,
    setDiscountTags: () => {},
    selectedDiscountId: null,
    setSelectedDiscountId: () => {},
    discountCoverId: null,
    setDiscountCoverId: () => {},
    discountCover: null,
    setDiscountCover: () => {},
    discountMedia: null,
    setDiscountMedia: () => {},
    discountMediaId: null,
    setDiscountMediaId: () => {},
    selectedGalleryId: null,
    setSelectedGalleryId: () => {},
    galleryTitle: null,
    setGalleryTitle: () => {},
    galleryDescription: null,
    setGalleryDescription: () => {},
    galleryIcon: null,
    setGalleryIcon: () => {},
    galleryColor: null,
    setGalleryColor: () => {},
    galleryTags: null,
    setGalleryTags: () => {},
    galleryMedia: null,
    setGalleryMedia: () => {},
    galleryMediaId: null,
    setGalleryMediaId: () => {},
    selectedAdId: null,
    setSelectedAdId: () => {},
    adPriority: null,
    setAdPriority: () => {},
    adLink: null,
    setAdLink: () => {},
    adTags: null,
    setAdTags: () => {},
    adPosition: null,
    setAdPosition: () => {},
    adStartDate: null,
    setAdStartDate: () => {},
    adEndDate: null,
    setAdEndDate: () => {},
    adTitle: null,
    setAdTitle: () => {},
    adDescription: null,
    setAdDescription: () => {},
    adCover: null,
    setAdCover: () => {},
    adCoverId: null,
    setAdCoverId: () => {},
    adNumOfSlide: null,
    setAdNumOfSlide: () => {},
    adLimit: null,
    setAdLimit: () => {},
    titleOfLink: null,
    setTitleOfLink: () => {},
    newstitleUrl: null,
    setNewstitleUrl: () => {},
    eventLinktitleUrl: null,
    setEventLinktitleUrl: () => {},
    tableData: null,
    setTableData: () => {},
    titleInput: null,
    setTitleInput: () => {},
    dataInput:null,
                setDataInput:()=>{},
});
